import React from 'react';
import PublicLayout, { LegalShell, PUBLIC_CONTACT_EMAIL } from '../../components/layout/PublicLayout';

const Terms = () => (
  <PublicLayout title="Terms of Use" description="VSKR Legal Terms of Use governing access to our website and services.">
    <LegalShell title="Terms of Use" updated="December 2025">
      <p>These Terms of Use ("Terms") govern your access to and use of the VSKR Legal website and services, including LIOS. By using our services, you agree to these Terms.</p>

      <h2>1. Use of the services</h2>
      <p>You agree to use the services lawfully and professionally, and not to misuse, disrupt, or attempt to gain unauthorised access to any part of the services or other users' data.</p>

      <h2>2. Accounts</h2>
      <p>You are responsible for maintaining the confidentiality of your account credentials and for activity under your account. Notify us promptly of any unauthorised use.</p>

      <h2>3. Your content</h2>
      <p>You retain rights to the content you add. You are responsible for ensuring you have the necessary rights to upload and process that content through the services.</p>

      <h2>4. Service availability</h2>
      <p>Some features may be offered on a testing or evaluation basis and may change or be discontinued. We do not guarantee uninterrupted availability.</p>

      <h2>5. No professional advice</h2>
      <p>The services are tools to assist legal professionals and do not constitute legal advice. You remain responsible for your professional judgement and work product.</p>

      <h2>6. Intellectual property</h2>
      <p>The VSKR Legal name, brand, software and website are owned by us or our licensors and are protected by applicable law. These Terms do not grant you rights to our trademarks or software beyond use of the services as provided.</p>

      <h2>7. Disclaimers</h2>
      <p>To the extent permitted by law, the services are provided "as is" without warranties of any kind. We do not warrant that the services will be error-free or meet every requirement.</p>

      <h2>8. Limitation of liability</h2>
      <p>To the extent permitted by law, we will not be liable for indirect, incidental, or consequential damages arising from your use of the services.</p>

      <h2>9. Termination</h2>
      <p>We may suspend or terminate access where these Terms are violated or where necessary to protect the services or other users. You may stop using the services and request account deletion at any time.</p>

      <h2>10. Changes to these Terms</h2>
      <p>We may update these Terms from time to time. Continued use after changes constitutes acceptance of the updated Terms.</p>

      <h2>11. Contact</h2>
      <p>Questions about these Terms can be sent to <a href={`mailto:${PUBLIC_CONTACT_EMAIL}`} className="text-[#2D8CFF] hover:underline">{PUBLIC_CONTACT_EMAIL}</a>.</p>
    </LegalShell>
  </PublicLayout>
);

export default Terms;
